import * as React from 'react';

export interface UseScriptProps {
	url: string;
	show?: boolean;
	beforeRender?: (script: HTMLScriptElement) => void;
	onLoad?: () => void;
	onError?: () => void;
}

const useScript = (props: UseScriptProps) => {
	const {
		url,
		onLoad,
		onError,
		beforeRender,
	} = props;
	const defaultOnLoad = () => console.log('Script successfully loaded.');
	const defaultOnError = () => console.log('Script failed to load');

	const scriptAlreadyIncluded = () => {
		const scripts = document.body.getElementsByTagName('script');
		for (let i = 0; i < scripts.length; i++) {
			const src = scripts[i].getAttribute('src');
			if (src === url) {
				return true;
			}
		}

		return false;
	};

	React.useEffect(() => {
		const script = document.createElement('script');

		script.src = url;
		script.async = true;

		beforeRender?.(script);

		script.addEventListener('load', onLoad || defaultOnLoad);
		script.addEventListener('error', onError || defaultOnError);

		if (!scriptAlreadyIncluded()) {
			document.body.appendChild(script);
		} else {
			onLoad && onLoad();
		}

		return () => {
			script.removeEventListener('load', onLoad || defaultOnLoad);
			script.removeEventListener('error', onError || defaultOnError);
		};
	}, [url]);
};

export default useScript;
